import { render, staticRenderFns } from "./serviceContent.vue?vue&type=template&id=fba41e1c&scoped=true&"
import script from "./serviceContent.vue?vue&type=script&lang=js&"
export * from "./serviceContent.vue?vue&type=script&lang=js&"
import style0 from "./serviceContent.vue?vue&type=style&index=0&id=fba41e1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba41e1c",
  null
  
)

export default component.exports